export enum PatientMedicationsConstants {
  NOT_IMPLEMENTED = 'patientMedications/NOT_IMPLEMENTED',
  SET_NAME = 'patientMedications/SET_NAME',
  SET_DOSE = 'patientMedications/SET_DOSE',
  SET_DOSE_UNITS = 'patientMedications/SET_DOSE_UNITS',
  SET_ROUTE = 'patientMedications/SET_ROUTE',
  SET_FREQUENCY = 'patientMedications/SET_FREQUENCY',
  SET_MEDICATION = 'patientMedications/SET_MEDICATION',
  ADD_MEDICATION = 'patientMedications/ADD_MEDICATION',
  DELETE_MEDICATION = 'patientMedications/DELETE_MEDICATION',
  SET_RESPONSE = 'patientMedications/SET_RESPONSE',
  SET_MEDICATIONS_LIST = 'patientMedications/SET_MEDICATIONS_LIST',
  SET_MEDICATION_PNNV = 'patientMedications/SET_MEDICATION_PNNV',
  SHOW_SINGLE_SELECT_LOOKUP = 'patientMedications/SHOW_SINGLE_SELECT_LOOKUP',
  SAVE_PATIENT_MEDICATIONS = 'patientMedications/SAVE_PATIENT_MEDICATIONS',
  SET_ARE_OPTIONS_LOADING = 'patientMedications/SET_ARE_OPTIONS_LOADING',
  SET_PATIENT_MEDICATIONS = 'patientMedications/SET_PATIENT_MEDICATIONS',
  SET_CURRENT_MEDICATION = 'patientMedications/SET_CURRENT_MEDICATION',
  SET_LAST_ORAL_INTAKE = 'patientMedications/SET_LAST_ORAL_INTAKE',
  SET_PATIENT_MEDICATION_PNNV_TOGGLE = 'patientMedications/SET_PATIENT_MEDICATION_PNNV_TOGGLE',
  RESET_STATE = 'patientMedications/RESET_STATE',
}
